import TracteursController from './tracteurs.controller';

export default {
    template: require('./tracteurs.html'),
    controller: TracteursController
};
